import React, { useEffect, useRef, useState, useCallback } from "react";
import { Outlet, useLocation } from "react-router-dom";
import "../App.css";
import "../fire.scss";
import { AnimatePresence } from "framer-motion";
import { UserProvider } from "../context/userContext";

const widthClasses = {
  "720": "w-full max-w-[720px]",
  "1080": "w-full max-w-[1080px]",
  "100%": "w-full",
};

const Home = () => {
  const location = useLocation();
  const scrollableEl = useRef(null);
  const touchStartY = useRef(null);

  const [containerWidth, setContainerWidth] = useState(() => {
    const saved = localStorage.getItem("containerWidth");
    return Object.keys(widthClasses).includes(saved) ? saved : "720";
  });

  const onTouchStart = useCallback((e) => {
    touchStartY.current = e.touches[0].clientY;
  }, []);

  const onTouchMove = useCallback(
    (e) => {
      const el = scrollableEl.current;
      if (!el) {
        e.preventDefault();
        return;
      }

      if (e.target.closest("#refer")) return;

      const scrollTop = el.scrollTop;
      const currentY = e.changedTouches[0].clientY;

      if (scrollTop <= 0 && touchStartY.current < currentY) {
        e.preventDefault();
      }
    },
    [scrollableEl]
  );

  useEffect(() => {
    const onContextMenu = (e) => e.preventDefault();
    const onKeyDown = (e) => {
      if (
        (e.ctrlKey && ["u", "s"].includes(e.key.toLowerCase())) ||
        (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === "i")
      ) {
        e.preventDefault();
      }
    };
    document.addEventListener("contextmenu", onContextMenu);
    document.addEventListener("keydown", onKeyDown);

    return () => {
      document.removeEventListener("contextmenu", onContextMenu);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, []);

  useEffect(() => {
    const tele = window.Telegram?.WebApp;
    if (!tele) return;

    document.body.style.backgroundColor = "#181818";
    tele.setBackgroundColor("#181818");
    tele.setHeaderColor("#181818");
    tele.ready();
    tele.expand();

    window.TelegramWebApp = tele;

    if (tele.HapticFeedback?.impactOccurred) tele.HapticFeedback.impactOccurred("medium");
    else if (navigator.vibrate) navigator.vibrate(100);
  }, []);

  useEffect(() => {
    const isDashboardRoute =
      location.pathname.startsWith("/dashboardAdx") ||
      location.pathname.startsWith("/dashboard");

    const footerEl = document.getElementById("footermain");

    if (isDashboardRoute) {
      if (footerEl) footerEl.style.display = "none";
    } else {
      if (footerEl) footerEl.style.display = "flex";
    }
  }, [location.pathname]);

  useEffect(() => {
    document.documentElement.addEventListener("touchstart", onTouchStart, {
      passive: false,
    });
    document.documentElement.addEventListener("touchmove", onTouchMove, {
      passive: false,
    });

    return () => {
      document.documentElement.removeEventListener("touchstart", onTouchStart);
      document.documentElement.removeEventListener("touchmove", onTouchMove);
    };
  }, [onTouchStart, onTouchMove]);

  return (
    <div className="relative w-full min-h-screen overflow-hidden">
      <div
        ref={scrollableEl}
        className="overflow-y-auto h-screen w-full scroll-smooth"
        tabIndex={-1}
      >
        <div className={`w-full ${widthClasses[containerWidth]} mx-auto p-0`}>

          <UserProvider>
            <AnimatePresence mode="wait">
              <React.Fragment key={location.pathname}>
                <Outlet />
              </React.Fragment>
            </AnimatePresence>
          </UserProvider>

        </div>
      </div>
    </div>
  );
};

export default Home;
